import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

class DisclaimerComponent extends PolymerElement {

    static get template() {
        return html
            `
        <style>
            .content{
                display: inline-flex;
                font-size: 16px;
                width: 100%;
                align-items: center;
                border-left: 3px solid #00839B;
                min-height: 44px;
            }
            .back-color {
                width: 4.25px;   
                height: 100%;
                background: #DA2128;
            }
            .icon-color {
                color: #00839B;
                margin-left: 20px;
                margin-right: 4px;
                --iron-icon-height: 22px;
                --iron-icon-width: 22px;
            }
            .centre {
                display: flex;
                align-items: center;
            }
            .pos{
                position: absolute;
                right: 1%;
            }
            .width {
                width: 100%;
                box-shadow: 0px 2px 1px rgb(0 0 0 / 5%), 0px 0px 1px rgb(0 0 0 / 25%);
                background: #FFFFFF;
            }
            .weight{
                font-weight: bold;
            }
            .info-note {
                font-weight: 700;
                font-family: SF Pro Display;
                font-style: normal;
                font-size: 16px;
                line-height: 24px;
                color: #000000;
            }
			.info-message {
                font-weight: 500;
                font-family: SF Pro Display;
                font-style: normal;
                font-size: 15px;
                line-height: 24px;
                color: #000000;
            }
            @media (max-width:479px)  {
                .content {
                    margin-left: 0px;
                    font-size: 16px;
                    width: 100%;
                    line-height: 20px;
                    display: flex;
                }
                .icon-color {
                    margin-right: 0px;
                    margin-left: 6px;
                }
            }
            ul {
                margin-block-start: 0em;
            }
            .close{
                padding-right: 10px;
                color: #00839B;
                margin-left: auto;
                cursor: pointer;
                --iron-icon-height: 20px;
                --iron-icon-width: 20px;
            }
        </style>
        <div class="error-container">
            <template is="dom-if" if="{{isShowComponent}}">
                <div class="width error">
                    <div class="content">
                        <div class="centre">
                            <iron-icon class="icon-color" icon="icons:info-outline"></iron-icon>
                        </div>
                        <div style="margin-left: 4px;">
                            
							<span class="info-message">{{infoMsg}}</span>
                        </div>
                        <div class="close">
                            <iron-icon on-tap="_hideErrorMessage" icon="close"></iron-icon>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        `
    }

    static get properties() {
        return {
            infoMsg: {
                type: String,
                value: '',
                notify: true
            },
            isShowComponent: {
                type: Boolean,
                value: true,
                notify: true
            },
            showCloseIcon: {
                type: Boolean,
                value: true,
                notify: true
            },
            closeClicked: {
                type: Boolean,
                value: false,
                notify: true
            }
        };
    }

    connectedCallback() {
        super.connectedCallback();
        // window.addEventListener('call-disclaimer-info', this._handleErrorEventListener.bind(this));
    }

    _handleErrorEventListener(e) {
        //var infoMsg = (e && e.detail) ? e.detail : 'Something went wrong!';
        //this.set('isShowComponent', true);
        //this.set('infoMsg', infoMsg);
        //document.getElementById('maincontent').scrollIntoView();
        //if (!this.closeClicked) {
        //    this._disapperErrorAutomatically();
        //}
    }

    _disapperErrorAutomatically() {
        var self = this;
        setTimeout(function () {
            self.set('isShowComponent', false);
        }, 1000 * 60)
    }

    _hideErrorMessage() {
        this.set('closeClicked', true);
        this.set('isShowComponent', false);
    }

}

customElements.define('disclaimer-component', DisclaimerComponent);